module.exports = __webpack_public_path__ + "img/tractor-dark-grey.e42e2c2b.svg";